
import React from "react";
import "./SpringOrFallCleaningService.css";

const SpringOrFallCleaningService = () => {
  return (
    <div className="springorfallcleaning-cleaning-container">
      <h1>Seasonal Cleaning to Rejuvenate Your Home</h1>
      <p>Our Spring or Fall Cleaning helps you clear out the clutter, refresh your space, and prepare your home for the season ahead with detailed, top-to-bottom care.</p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Deep dusting and cobweb removal</li>
<li>Cleaning inside cabinets and drawers</li>
<li>Washing windows and mirrors</li>
<li>Vacuuming under furniture and cushions</li>
<li>Refreshing baseboards and air vents</li>

      </ul>
    </div>
  );
};

export default SpringOrFallCleaningService;
